export default __webpack_public_path__ + "static/media/game1.9bb91b6f.svg";